import type { AdminLeadDetail } from '../../api/client';

type TimelineItem = AdminLeadDetail['timeline'][number];

const MEANINGFUL_EVENTS = new Set([
  'bot_start', 'miniapp_open', 'tryon_opened', 'tryon_started', 'photo_uploaded',
  'design_library_opened', 'design_selected', 'custom_design_uploaded', 'editor_started',
  'result_viewed', 'tryon_result_created', 'result_downloaded', 'booking_started',
  'booking_artist_selected', 'booking_date_selected', 'booking_time_selected',
  'booking_submitted', 'quiz_started', 'quiz_step_completed', 'quiz_completed',
]);

export function meaningfulLeadTimeline(items: TimelineItem[]): TimelineItem[] {
  const hasCreatedResult = items.some((item) => item.event === 'tryon_result_created');
  const seen = new Set<string>();
  return items.filter((item) => {
    if (!MEANINGFUL_EVENTS.has(item.event)) return false;
    if (hasCreatedResult && item.event === 'result_viewed') return false;
    const key = `${item.event}:${item.createdAt}:${JSON.stringify(item.metadata || {})}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function timelineMetadataCopy(item: TimelineItem): string {
  const metadata = item.metadata || {};
  if (item.event === 'design_selected') return String(metadata.designName || metadata.design || '');
  if (item.event === 'booking_artist_selected') return String(metadata.artistName || metadata.artist || '');
  if (item.event === 'booking_date_selected') return String(metadata.date || '');
  if (item.event === 'booking_time_selected') return String(metadata.time || '');
  return '';
}
